export const wiseAllowedCountries = [
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AL",
        "name": "Albania"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "DZ",
        "name": "Algeria"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AS",
        "name": "American Samoa"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AD",
        "name": "Andorra"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AO",
        "name": "Angola"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AI",
        "name": "Anguilla"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AQ",
        "name": "Antarctica"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AG",
        "name": "Antigua and Barbuda"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AR",
        "name": "Argentina"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AM",
        "name": "Armenia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AW",
        "name": "Aruba"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AU",
        "name": "Australia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AT",
        "name": "Austria"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AZ",
        "name": "Azerbaijan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BS",
        "name": "Bahamas"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BH",
        "name": "Bahrain"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BD",
        "name": "Bangladesh"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BB",
        "name": "Barbados"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BE",
        "name": "Belgium"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BZ",
        "name": "Belize"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BJ",
        "name": "Benin"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BM",
        "name": "Bermuda"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BT",
        "name": "Bhutan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BO",
        "name": "Bolivia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BQ",
        "name": "Bonaire"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BA",
        "name": "Bosnia and Herzegovina"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BW",
        "name": "Botswana"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BV",
        "name": "Bouvet Island"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BR",
        "name": "Brazil"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "IO",
        "name": "British Indian Ocean Territory"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "VG",
        "name": "British Virgin Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BN",
        "name": "Brunei Darussalam"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BG",
        "name": "Bulgaria"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BF",
        "name": "Burkina Faso"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "KH",
        "name": "Cambodia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CM",
        "name": "Cameroon"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CA",
        "name": "Canada"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CV",
        "name": "Cape Verde"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "KY",
        "name": "Cayman Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CL",
        "name": "Chile"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CN",
        "name": "China"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CX",
        "name": "Christmas Island"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CC",
        "name": "Cocos (Keeling) Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CO",
        "name": "Colombia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "KM",
        "name": "Comoros"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CK",
        "name": "Cook Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CR",
        "name": "Costa Rica"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "HR",
        "name": "Croatia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CW",
        "name": "Curaçao"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CY",
        "name": "Cyprus"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CZ",
        "name": "Czech Republic"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CI",
        "name": "Côte d'Ivoire"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "DK",
        "name": "Denmark"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "DJ",
        "name": "Djibouti"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "DM",
        "name": "Dominica"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "DO",
        "name": "Dominican Republic"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "EC",
        "name": "Ecuador"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "EG",
        "name": "Egypt"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SV",
        "name": "El Salvador"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GQ",
        "name": "Equatorial Guinea"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "EE",
        "name": "Estonia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "ET",
        "name": "Ethiopia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "FK",
        "name": "Falkland Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "FO",
        "name": "Faroe Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "FJ",
        "name": "Fiji"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "FI",
        "name": "Finland"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "FR",
        "name": "France"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GF",
        "name": "French Guiana"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PF",
        "name": "French Polynesia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TF",
        "name": "French Southern Territories"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GA",
        "name": "Gabon"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GM",
        "name": "Gambia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GE",
        "name": "Georgia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "DE",
        "name": "Germany"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GH",
        "name": "Ghana"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GI",
        "name": "Gibraltar"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GR",
        "name": "Greece"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GL",
        "name": "Greenland"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GD",
        "name": "Grenada"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GP",
        "name": "Guadeloupe"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GU",
        "name": "Guam"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GT",
        "name": "Guatemala"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GG",
        "name": "Guernsey"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GN",
        "name": "Guinea"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GW",
        "name": "Guinea-Bissau"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GY",
        "name": "Guyana"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "HT",
        "name": "Haiti"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "HM",
        "name": "Heard Island and McDonald Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "HN",
        "name": "Honduras"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "HK",
        "name": "Hong Kong"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "HU",
        "name": "Hungary"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "IS",
        "name": "Iceland"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "IN",
        "name": "India"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "ID",
        "name": "Indonesia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "IE",
        "name": "Ireland"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "IM",
        "name": "Isle of Man"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "IL",
        "name": "Israel"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "IT",
        "name": "Italy"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "JM",
        "name": "Jamaica"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "JP",
        "name": "Japan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "JE",
        "name": "Jersey"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "JO",
        "name": "Jordan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "KZ",
        "name": "Kazakhstan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "KE",
        "name": "Kenya"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "KI",
        "name": "Kiribati"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "XK",
        "name": "Kosovo"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "KW",
        "name": "Kuwait"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "KG",
        "name": "Kyrgyzstan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "LA",
        "name": "Laos"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "LV",
        "name": "Latvia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "LB",
        "name": "Lebanon"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "LS",
        "name": "Lesotho"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "LR",
        "name": "Liberia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "LI",
        "name": "Liechtenstein"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "LT",
        "name": "Lithuania"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "LU",
        "name": "Luxembourg"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MO",
        "name": "Macao"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MK",
        "name": "Macedonia, Former Yugoslav Republic of"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MG",
        "name": "Madagascar"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MW",
        "name": "Malawi"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MY",
        "name": "Malaysia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MV",
        "name": "Maldives"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "ML",
        "name": "Mali"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MT",
        "name": "Malta"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MH",
        "name": "Marshall Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MQ",
        "name": "Martinique"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MR",
        "name": "Mauritania"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MU",
        "name": "Mauritius"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "YT",
        "name": "Mayotte"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MX",
        "name": "Mexico"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "FM",
        "name": "Micronesia, Federated States of"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MD",
        "name": "Moldova"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MC",
        "name": "Monaco"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MN",
        "name": "Mongolia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "ME",
        "name": "Montenegro"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MS",
        "name": "Montserrat"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MA",
        "name": "Morocco"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MZ",
        "name": "Mozambique"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NA",
        "name": "Namibia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NR",
        "name": "Nauru"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NP",
        "name": "Nepal"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NL",
        "name": "Netherlands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NC",
        "name": "New Caledonia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NZ",
        "name": "New Zealand"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NI",
        "name": "Nicaragua"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NE",
        "name": "Niger"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NG",
        "name": "Nigeria"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NU",
        "name": "Niue"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NF",
        "name": "Norfolk Island"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MP",
        "name": "Northern Mariana Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "NO",
        "name": "Norway"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "OM",
        "name": "Oman"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PK",
        "name": "Pakistan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PW",
        "name": "Palau"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PS",
        "name": "Palestine"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PA",
        "name": "Panama"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PG",
        "name": "Papua New Guinea"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PY",
        "name": "Paraguay"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PE",
        "name": "Peru"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PH",
        "name": "Philippines"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PN",
        "name": "Pitcairn Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PL",
        "name": "Poland"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PT",
        "name": "Portugal"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PR",
        "name": "Puerto Rico"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "QA",
        "name": "Qatar"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "RO",
        "name": "Romania"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "RW",
        "name": "Rwanda"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "RE",
        "name": "Réunion"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "BL",
        "name": "Saint Barthélemy"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SH",
        "name": "Saint Helena"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "KN",
        "name": "Saint Kitts and Nevis"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "LC",
        "name": "Saint Lucia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "MF",
        "name": "Saint Martin (French part)"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "PM",
        "name": "Saint Pierre and Miquelon"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "VC",
        "name": "Saint Vincent and the Grenadines"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "WS",
        "name": "Samoa"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SM",
        "name": "San Marino"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "ST",
        "name": "Sao Tome and Principe"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SA",
        "name": "Saudi Arabia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SN",
        "name": "Senegal"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "RS",
        "name": "Serbia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SC",
        "name": "Seychelles"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SL",
        "name": "Sierra Leone"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SG",
        "name": "Singapore"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SX",
        "name": "Sint Maarten (Dutch part)"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SK",
        "name": "Slovakia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SI",
        "name": "Slovenia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SB",
        "name": "Solomon Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "ZA",
        "name": "South Africa"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GS",
        "name": "South Georgia and the South Sandwich Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "KR",
        "name": "South Korea"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "ES",
        "name": "Spain"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "LK",
        "name": "Sri Lanka"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SR",
        "name": "Suriname"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SJ",
        "name": "Svalbard and Jan Mayen"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SZ",
        "name": "Swaziland"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "SE",
        "name": "Sweden"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "CH",
        "name": "Switzerland"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TW",
        "name": "Taiwan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TJ",
        "name": "Tajikistan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TZ",
        "name": "Tanzania"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TH",
        "name": "Thailand"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TL",
        "name": "Timor-Leste"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TG",
        "name": "Togo"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TK",
        "name": "Tokelau"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TO",
        "name": "Tonga"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TT",
        "name": "Trinidad and Tobago"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TN",
        "name": "Tunisia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TR",
        "name": "Turkey"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TM",
        "name": "Turkmenistan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TC",
        "name": "Turks and Caicos Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "TV",
        "name": "Tuvalu"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "UG",
        "name": "Uganda"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "UA",
        "name": "Ukraine"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AE",
        "name": "United Arab Emirates"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "GB",
        "name": "United Kingdom"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "US",
        "name": "United States"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "UM",
        "name": "United States Minor Outlying Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "VI",
        "name": "United States Virgin Islands"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "UY",
        "name": "Uruguay"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "UZ",
        "name": "Uzbekistan"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "VU",
        "name": "Vanuatu"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "VA",
        "name": "Vatican City"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "VN",
        "name": "Vietnam"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "WF",
        "name": "Wallis and Futuna"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "EH",
        "name": "Western Sahara"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "ZM",
        "name": "Zambia"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "ZW",
        "name": "Zimbabwe"
    },
    {
        "__typename": "AccountRequirementsValuesAllowed",
        "key": "AX",
        "name": "Åland Islands"
    }
]